module.exports = __webpack_public_path__ + "static/media/bootstrap.3cf41886.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/bootstrap.png
 ** module id = 213
 ** module chunks = 0
 **/